import * as React from 'react';
import { Col, Row, Space, Typography } from 'antd';
import { SpidLoginButton } from './spid-button/SpidLoginButton';
import { EidasLoginButton } from './eidas-button/EidasLoginButton';
import { SpidInfoPopover } from './spid-button/SpidInfoPopover';
import { CieLoginButton } from './cie-button/CieLoginButton';
import './OpenWebLoginButtons.scss';

export interface OpenWebLoginButtonsProps {
  divider?: boolean;
}

/**
 * Login di un utente con SPID - CIE - EIDAS
 */
export function OpenWebLoginButtons() {
  return (
    <Row justify="center" className="open-web-login-buttons">
      <Col>
        <Row className="login-buttons-respond-row">
          <Col className="login-button-respond-col">
            <Space direction="horizontal" size={5} align="start">
              <SpidLoginButton />
              <SpidInfoPopover />
            </Space>
          </Col>
          <Col className="login-button-respond-col">
            <CieLoginButton />
          </Col>
          <Col className="login-button-respond-col">
            <EidasLoginButton />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
